import { gql } from '@/__generated__';
import { FluidContainer } from '@/components/Atoms/Layouts';
import createBlock, { BlockMeta } from '@/components/Blocks/createBlock';
import PageCard from '@/components/Cards/PageCard/PageCard';
import { excludeEmptyTypedElements } from '@liquorice/utils';
import { BlocksOwnProps } from '../../Blocks';

export const INTERNAL_PAGE_CARDS_BLOCK_FRAGMENT = gql(`
  fragment InternalPageCardsBlock on blocks_blockInternalPageCards_BlockType {
    id
    heading
    entryMultiple {
      ...PageCard
    }
  }
`);

export interface InternalPageCardsBlockProps extends BlockMeta, BlocksOwnProps {}

const InternalPageCardsBlock = createBlock(
  INTERNAL_PAGE_CARDS_BLOCK_FRAGMENT,
  async (data, { pageSection, anchor }: InternalPageCardsBlockProps) => {
    const pages = excludeEmptyTypedElements(data.entryMultiple);
    const isHome = pageSection === 'home';

    return (
      <FluidContainer id={anchor} width={isHome ? 'full' : 'article'}>
        {data.heading && <h3 className="mb-8">{data.heading}</h3>}
        <div
          className={`grid w-full justify-stretch gap-8 md:grid-cols-2 ${isHome ?? 'lg:grid-cols-3'}`}>
          {pages.map((page, i) => {
            return <PageCard key={i} data={page} />;
          })}
        </div>
      </FluidContainer>
    );
  },
);

export default InternalPageCardsBlock;
